import { NavLink } from 'react-router'
import { useTranslation } from 'react-i18next'
import type { SubNavItem } from './navConfig'
import styles from './SubNavPills.module.css'

export function SubNavPills({ items }: { items: SubNavItem[] }) {
  const { t } = useTranslation()
  return (
    <div className={styles.row} aria-label="Section navigation">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end
          className={({ isActive }) =>
            `${styles.pill}${isActive ? ' ' + styles.pillActive : ''}`
          }
        >
          {t(item.labelKey)}
        </NavLink>
      ))}
    </div>
  )
}
